import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { useApiBase } from "../../base/api-base";
import { EnumStatusPedidoLocal } from "../../../../model/enums/enum-status-pedido-local";
import { PedidoDadosEntrega } from "../../../../model/api/pedidos/pedido-dados-entrega";

export function usePutAlterarStatusPedido() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putAlterarStatusPedido = useCallback(
        (empresaId: string, pedidoId: string, status: EnumStatusPedidoLocal, pedidoDadosEntrega?: PedidoDadosEntrega) => {
            return invocarApi({
                url: `/${VariaveisAmbiente.pedidosVersion}/empresa/${empresaId}/pedido-salao/${pedidoId}/alterar-status/${status}`,
                method: "PUT",
                data: pedidoDadosEntrega ?? {},
                baseURL: `${VariaveisAmbiente.apiPedidosUrl}/api`,
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        putAlterarStatusPedido,
    };
}